// eslint-disable-next-line no-unused-vars
import { Offer } from '../domain/Offer'
import store from '../store'

export const DATA_KEY = 'current_offer'
export const CHANNEL_KEY = 'channel'
export const TELEVENDAS_ID_KEY = 'televendas_id'
export const OFFERS = 'offers'

/**
 * store selected offer
 * @param {string} id
 */
const setOffer = id => store.set(DATA_KEY, id)

/**
 * get current offer
 * @returns {Promise<String>}
 */
const getOffer = () => store.get(DATA_KEY)

/**
 * store offers
 * @param {string} id
 * @param {Offer[]} offers
 */
const setOffers = offers => store.set(OFFERS, offers)

/**
 * get current offers
 * @returns {Promise<Offer[]>}
 */
const getOffers = () => store.get(OFFERS)

/**
 * store channel
 * @param {string} id
 */
const setChannel = channel => store.set(CHANNEL_KEY, channel)

/**
 * get channel
 * @returns {Promise<String>}
 */
const getChannel = () => store.get(CHANNEL_KEY)

/**
 * store televendasId
 * @param {string} id
 */
const setTelevendasId = id => store.set(TELEVENDAS_ID_KEY, id)

export { setOffer, getOffer, setOffers, getOffers, setChannel, getChannel, setTelevendasId }
